import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const login = (login, password) => {
  return api.post(
    `${ApiEndpointConstants.LOGIN}`,
    { login, password },
    {
      skipAuth: true, // 登录请求不需要token
    }
  );
};
